import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AnnouncementPopup from '@/views/manageCenter/announcementManagement/components/announcementPopup.vue';
import { getAnnouncementCenterList } from '@/api/manageCenter';

// tab 选项：unread_un_callback=未读/未回执（近14天），all=全部（近365天）
var TAB_OPTIONS = [{
  label: '未读/未回执',
  value: 'unread_un_callback',
  countKey: 'unread_un_callback_count'
}, {
  label: '全部',
  value: 'all',
  countKey: 'all_count'
}];
export default {
  name: 'NoticeCenter',
  components: {
    AnnouncementPopup: AnnouncementPopup
  },
  data: function data() {
    return {
      // 当前 tab：默认未读未回执
      activeTab: 'unread_un_callback',
      // tab 数量：取列表接口响应字段
      tabCounts: {},
      // 透传给内容组件作为列表请求函数
      getAnnouncementCenterList: getAnnouncementCenterList
    };
  },
  computed: {
    // tab 文案：接口返回数量后拼接为「标签(数量)」展示
    tabOptions: function tabOptions() {
      var _this = this;
      return TAB_OPTIONS.map(function (item) {
        var count = _this.tabCounts[item.countKey];
        return _objectSpread(_objectSpread({}, item), {}, {
          label: count !== undefined ? "".concat(item.label, "\uFF08").concat(count, "\uFF09") : item.label
        });
      });
    },
    // 列表请求参数：仅传 tab，分页由内容组件内部维护，变化时内容组件自动重新拉取
    listParams: function listParams() {
      return {
        tab: this.activeTab
      };
    }
  },
  methods: {
    // 内容组件列表加载完成：同步 tab 数量
    handleLoaded: function handleLoaded(res) {
      this.tabCounts = res.data || {};
    },
    // 阅读已读/回执成功的统计变化：本地同步 tab 数量，不重新拉取列表（切 tab 时再拉）
    // 「未读/未回执」数量随未处理数（pendingDelta）增减，「全部」数量不变
    handleStatChange: function handleStatChange(delta) {
      var count = this.tabCounts.unread_un_callback_count;
      if (typeof count === 'number' && delta.pendingDelta) {
        this.tabCounts = _objectSpread(_objectSpread({}, this.tabCounts), {}, {
          unread_un_callback_count: Math.max(0, count + delta.pendingDelta)
        });
      }
      // 继续向上传递：导航栏同步顶部未读/未回执统计与铃铛徽标数量
      this.$emit('stat-change', delta);
    }
  }
};